export default __webpack_public_path__ + "static/media/lotusiobottomlogo.052a3606.png";